import {
  Injectable
} from '@angular/core';
import {
  Observable
, 
  BehaviorSubject
, 
  Subscription
} from 'rxjs';
import {
  ApiService
} from '../services/api/index';
import {
  HttpParams
} from '@angular/common/http';
import {
  GridDataResult
} from '@progress/kendo-angular-grid';
import {UserContext} from '../services/user-context';

@Injectable()
export class ShopService extends BehaviorSubject<GridDataResult> {
  public subscription: Subscription;

  constructor(private api: ApiService, private userContext: UserContext) {
    super((<GridDataResult>{
      data: [],
      total: 0
    }));
  }

  public getList(page: number, limit: number, cb: any, locationId?: string) {
    const params = new HttpParams()
    .set('page', page.toLocaleString())
    .set('limit', limit.toString())
    .set('location', locationId);

    this.subscription = this.api.get<GridDataResult>(`/account/${this.userContext.account._id}/esale`, params)
      .subscribe(result => {
        super.next(result);
      });
  }
}
